<input [(ngModel)]="value" [required]="required">
